import { useEffect, useRef, type KeyboardEvent } from 'react'
import { ProtoButton } from '@/features/d0/states'

// The first-visit offer. Non-modal: the page stays usable, and Later (or Escape) never brings it back.
export default function WelcomeOffer({ onStart, onLater, mobile }: { onStart: () => void; onLater: () => void; mobile: boolean }) {
  const headingRef = useRef<HTMLHeadingElement>(null)
  useEffect(() => headingRef.current?.focus({ preventScroll: true }), [])

  const onKeyDown = (e: KeyboardEvent) => {
    if (e.key !== 'Escape' || e.defaultPrevented) return
    e.preventDefault()
    onLater()
  }

  return (
    <div className={`t0-card ${mobile ? 't0-card--bottom' : 't0-card--right'}`} role="dialog" aria-modal="false" aria-label="Welcome to ZUPA" onKeyDown={onKeyDown}>
      <p className="s6-kicker t0-card__eyebrow">Workspace guide</p>
      <h2 className="t0-card__title" ref={headingRef} tabIndex={-1}>Want a guided tour?</h2>
      <p className="t0-card__text">
        Eighteen short chapters show where everything is, using your own workspace. You do each step yourself; you can pause, skip or leave at any time.
      </p>
      <div className="t0-card__actions">
        <ProtoButton className="z-primary" onClick={onStart}>Start</ProtoButton>
        <ProtoButton className="z-quiet" onClick={onLater}>Later</ProtoButton>
      </div>
    </div>
  )
}
